// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld/base/core';
import 'myWorld/features/ddFeature';

myw.EsriFeature = myw.DDFeature.extend({
    /**
     * @class  Feature that represents an address search result
     * @param  {featureData} featureData Feature details
     * @augments Feature
     * @constructs
     */
    initialize(featureData) {
        //in the conversion from service results to geojson the leaflet Esri Plugin can get the id from the wrong field
        if (this.featureDD.key_name) {
            featureData.id = featureData.properties[this.featureDD.key_name];
        }

        // Call the super constructor
        myw.DDFeature.prototype.initialize.call(this, featureData);

        this.displayFieldName = featureData.displayFieldName;
    },

    /**
     * Returns an HTML string with the description to be shown in a myWorld results listing
     * Assumes the result will be enclosed in HTML where an <a> tag has started
     * @return {string} The html string with the formatted address
     */
    getTitle() {
        if (this.featureDD.title_expr) return myw.DDFeature.prototype.getTitle.call(this);

        const typeExternalName = this.featureDD.external_name,
            title = this.displayFieldName && this.properties[this.displayFieldName];

        if (title) {
            return `${typeExternalName}: ${title}`;
        } else {
            return typeExternalName;
        }
    }
});

export default myw.EsriFeature;
